import { useEffect, useState } from "react";

// 휴대폰 폭(md 48em 미만)인가 — 인라인 style 로 그린 화면이 폭에 따라 배치를 바꿀 때 쓴다.
// Chakra useBreakpointValue 대신 직접 matchMedia 를 본다 — jsdom(기존 컴포넌트 테스트)에는 matchMedia 가 없어
// useBreakpointValue 가 throw 한다. 없으면 데스크톱으로 간주한다(fail-open).
// 첫 렌더에서 바로 읽어 휴대폰에서 데스크톱 배치가 한 번 그려졌다 바뀌지 않는다.
// GuideHint(바텀시트 판정)에 있던 것을 2026-10-02 정산 관리 창(NewSettlementModal)과 같이 쓰려고 옮겼다.
export const MOBILE_QUERY = "(max-width: 47.99em)";

function readMatches() {
  try {
    return typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(MOBILE_QUERY).matches
      : false;
  } catch {
    return false;
  }
}

export function useIsMobileViewport() {
  const [isMobile, setIsMobile] = useState(readMatches);
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return undefined;
    let mq;
    try {
      mq = window.matchMedia(MOBILE_QUERY);
    } catch {
      return undefined;
    }
    const on = () => setIsMobile(mq.matches);
    on();
    if (mq.addEventListener) mq.addEventListener("change", on);
    else mq.addListener(on);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", on);
      else mq.removeListener(on);
    };
  }, []);
  return isMobile;
}

export default useIsMobileViewport;
